

export const FORCE_RESET_TOGGLE_DISPLAY = "Force Reset?";